import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import InputsFromRefurbishment41_5aTable from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const InputsFromRefurbishment41_5a = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("INPUTS_FROM_REFURBISHMENT") || "Inputs from refurbishment"}
        subDescription={t("INPUTS_FROM_REFURBISHMENT_41_5A_DESC") || "These are the resources used to renovate or upgrade the product so it regains full performance or extended lifespan. Typical inputs include new components, coatings, cleaning materials, or energy."}
        isNormal={true}
        number={"41.5a"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`inputs-from-refurbishment-41-5a-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <InputsFromRefurbishment41_5aTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default InputsFromRefurbishment41_5a;

